import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=9fec4ce4&scoped=true"
import script from "./EditableItem.vue?vue&type=script&lang=js"
export * from "./EditableItem.vue?vue&type=script&lang=js"
import style0 from "./EditableItem.vue?vue&type=style&index=0&id=9fec4ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fec4ce4",
  null
  
)

export default component.exports